import React from "react";
import Storylist from "../Storylist";
import { observer } from "mobx-react";

const lists = [
  ["a", "b", "d", "e", "f", "i"],
  ["a", "b", "d", "e", "f", "i"],
  ["j", "k", "l", "m"],
  ["o", "p", "q", "r", "s", "t", "u"],
  ["o", "p", "q", "r", "s", "t", "u"]
];

export default observer(({ artistName, book, order, setpImage }) => (
  <div className="story-selection pd-15">
    <img
      style={{
        padding: "16px 0px 38px",
        width: "100%",
        height: "auto"
      }}
      src={require(`../../imgs/${setpImage}`)}
    />

    <div className="step">
      <span className="step-title-alt">{"STEP 1 "}</span>
      <span className="step-txt">{"９つの選択文の中から２つを選択（P4 - P11に該当）"}</span>
      <Storylist
        artistName={artistName}
        book={book}
        disabled={book.stories.map(v => v.substring(0, 1))}
        list={
          book.children > 0 ? lists[0].concat(["c", "g", "h"]).sort() : lists[0]
        }
        onSelect={selected => book.setStory(0, selected)}
        selected={book.stories[0].substring(0, 1)}
        storyNumber={1}
      />
      <Storylist
        artistName={artistName}
        book={book}
        disabled={book.stories.map(v => v.substring(0, 1))}
        list={
          book.children > 0 ? lists[1].concat(["c", "g", "h"]).sort() : lists[1]
        }
        onSelect={selected => book.setStory(1, selected)}
        selected={book.stories[1].substring(0, 1)}
        storyNumber={2}
      />
    </div>

    <div className="step step-2">
      <span className="step-title-alt">{"STEP 2 "}</span>
      <span className="step-txt">{"５つの選択文の中から１つを選択（P12 - P15に該当）"}</span>
      <Storylist
        artistName={artistName}
        book={book}
        disabled={book.stories.map(v => v.substring(0, 1))}
        list={book.children > 0 ? lists[2].concat(["n"]).sort() : lists[2]}
        onSelect={selected => book.setStory(2, selected)}
        selected={book.stories[2].substring(0, 1)}
        storyNumber={3}
      />
    </div>

    <div className="step step-2">
      <span className="step-title-alt">{"STEP 3 "}</span>
      <span className="step-txt">{"７つの選択文の中から２つを選択（P16 - P23に該当）"}</span>
      <Storylist
        artistName={artistName}
        book={book}
        disabled={book.stories.map(v => v.substring(0, 1))}
        list={lists[3]}
        onSelect={selected => book.setStory(3, selected)}
        selected={book.stories[3].substring(0, 1)}
        storyNumber={4}
      />
      <Storylist
        artistName={artistName}
        book={book}
        disabled={book.stories.map(v => v.substring(0, 1))}
        list={lists[4]}
        onSelect={selected => book.setStory(4, selected)}
        selected={book.stories[4].substring(0, 1)}
        storyNumber={5}
      />
    </div>
    <div
      style={{
        "paddingTop": "16px",
      }}
      className="btn-wrap"
    >
      <button
        disabled={book.stories.indexOf("") !== -1}
        onClick={() => order.saveStories()}
        className="btn product-btn"
      >
        保存して次へ
        <img
          src="https://cdn.shopify.com/s/files/1/0012/2568/7076/files/arrow-right-purple.png?13701503969354364487"
          className="btn-arrow"
        />
      </button>
    </div>
  </div>
));



// WEBPACK FOOTER //
// ./src/components/steps/StorySelection.js